<template>
    <div class="list">
        <el-form :inline="true" size="small" :model="listQuery" class="demo-form-inline">
            <el-form-item>
                <el-input v-model="listQuery.keyword_search" clearable style="width: 200px" class="name-input" placeholder="输入标签名称搜索" />
            </el-form-item>

            <el-form-item class="add">
                <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">筛选</el-button>
                <el-button v-if="hasAdd" type="primary" size="small" icon="el-icon-plus" @click="showDialog('add')">新建</el-button>
            </el-form-item>
        </el-form>

        <el-table v-loading="listLoading" :data="list" border style="width: 100%" align="center">
            <el-table-column prop="name" label="标签名称" align="center" />
            <el-table-column prop="article_num" label="标签关联文章数量" align="center" />
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button v-if="hasEdit" type="primary" size="mini" class="op_buttton" @click="showDialog('edit',scope)">编辑</el-button>
                    <el-button v-if="hasDelete" type="danger" size="mini" class="op_buttton" @click="showDialog('delete',scope)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page"><pagination v-show="total > 0" :total="total" :page.sync="listQuery.page_index" :limit.sync="listQuery.page_size" @pagination="getList" /></div>

        <common-dialog :title="dialogTitle" :dialog-visible="dialogVisible" :show-btns="showBtns">
            <el-form :model="tagInfo">
                <el-form-item label="标签名称" label-width="80px">
                    <el-input v-model="tagInfo.name" placeholder="请输入标签名称"></el-input>
                </el-form-item>
                <el-form-item class="button_wrap">
                    <el-button @click="dialogVisible=false">返回</el-button>
                    <el-button type="primary" @click="dialogConfirmClick">保存</el-button>
                </el-form-item>
            </el-form>
        </common-dialog>

    </div>
</template>
<script>
import { getArticleTag, addArticleTag, deleteArticleTag, editArticleTag } from '@/api/college';
import Pagination from '@/components/Pagination';
import CommonDialog from '@/components/CommonDialog';
import operations from '../../mixins/operations';

export default {
    components: { Pagination, CommonDialog },
    mixins: [operations],
    data() {
        return {
            showBtns: false,
            dialogTitle: "",
            dialogType: "",
            list: [],
            dialogVisible: false,
            total: 0,
            listQuery: {
                page_index: 1,
                page_size: 10,
                keyword_search: ""
            },
            tagInfo: {
                name: ""
            },
            id: "",
            listLoading: false
        };
    },
    computed: {
        hasAdd() {
            return this.operations.includes('新建标签');
        },
        hasEdit() {
            return this.operations.includes('编辑标签');
        },
        hasDelete() {
            return this.operations.includes('删除标签');
        }
    },

    async mounted() {
        this.getList();
    },

    methods: {
        async getList(params = this.listQuery) {
            this.listLoading = true;
            const { total, data } = await getArticleTag(params);
            this.listLoading = false;
            this.total = total;
            this.list = data;
        },

        showDialog(value, scope) {
            if (value == "delete") {
                this.$confirm(`是否删除该标签？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    const res = await deleteArticleTag(scope.row.id);
                    if (res == true) {
                        this.getList();
                        this.$notify({ title: '标签删除成功', type: 'success' });
                        this.dialogVisible = false
                    } else {
                        this.$notify.error({ title: '操作失败' });
                    }
                }).catch(() => {

                })
            } else {
                if (value == "edit") {
                    this.dialogTitle = "编辑标签";
                    this.id = scope.row.id;
                    this.tagInfo = Object.assign({}, scope.row)
                } else if (value == "add") {
                    this.tagInfo = {}
                    this.dialogTitle = "新建标签"
                }
                this.dialogType = value;
                this.dialogVisible = true
            }
        },

        async dialogConfirmClick() {
            const { name } = this.tagInfo;
            if (!name) return this.$notify.error({ title: '请输入标签名称' });
            if (this.dialogType == "edit") {
                const res = await editArticleTag(this.id, this.tagInfo);
                if (res == true) {
                    this.getList();
                    this.$notify({ title: '标签编辑成功', type: 'success' });
                    this.dialogVisible = false
                } else {
                    this.$notify.error({ title: '操作失败' });
                }
            } else if (this.dialogType == "add") {
                const res = await addArticleTag(this.tagInfo);
                if (res == true) {
                    this.getList();
                    this.$notify({ title: '新增标签成功', type: 'success' });
                    this.dialogVisible = false
                } else {
                    this.$notify.error({ title: '操作失败' });
                }
            }
        }
    }
};
</script>

<style lang="less" scoped>
    .list{
        .add{
            float: right;
            margin-bottom: 20px;
        }
        .button_wrap{
            text-align: center;
            margin-top: 30px;
        }
        .el-form-item:last-child{
            margin-bottom: 0;
        }
        .op_buttton{
            margin-bottom: 10px;
        }
        .viewer-img{
            width: 124px;
            height: 80px;
        }
        /deep/ .el-input{
            width: 100%;
        }
    }
</style>
